import { useEffect, useState } from "react";
import { useReducedMotion } from "framer-motion";

const WORDS = ["inspire", "surprindă", "implice", "mobilizeze"];

export default function TypeWord() {
  const reduce = useReducedMotion();
  const [index, setIndex] = useState(0);
  const [sub, setSub] = useState(WORDS[0].length);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (reduce) return undefined;
    const current = WORDS[index];
    let delay;
    if (!deleting && sub === current.length) delay = 1500; // pauză pe cuvântul complet
    else if (deleting && sub === 0) delay = 420; // pauză înainte de următorul cuvânt
    else delay = deleting ? 55 : 105; // viteză ștergere / scriere

    const t = setTimeout(() => {
      if (!deleting && sub < current.length) setSub(sub + 1);
      else if (!deleting && sub === current.length) setDeleting(true);
      else if (deleting && sub > 0) setSub(sub - 1);
      else {
        setDeleting(false);
        setIndex((index + 1) % WORDS.length);
      }
    }, delay);
    return () => clearTimeout(t);
  }, [sub, deleting, index, reduce]);

  const text = reduce ? WORDS[0] : WORDS[index].slice(0, sub);

  return (
    <span className="text-brand">
      <span className="sr-only">inspire</span>
      <span aria-hidden="true">
        {text}
        {!reduce && <span className="type-caret" />}
      </span>
    </span>
  );
}
